import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=0f0dd45d&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "@/scss/login.scss?vue&type=style&index=0&id=0f0dd45d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0dd45d",
  null
  
)

export default component.exports